<template>
  <section id="wit-store">
    <header class="clearfix">
      <div>
        {{ selectInfo.city }}
      </div>
      <div @click="openPicker">切换地区<i class="iconfont icon-arrow"></i></div>
    </header>
    <mt-swipe :auto="4000">
      <mt-swipe-item v-for="(item, index) in bannerList" :key="index">
        <a :href="item.bannerLink" v-if="item.bannerStatus == 1">
          <img :src="item.bannerImg" alt="" class="banner" />
        </a>
      </mt-swipe-item>
    </mt-swipe>
    <!-- <div class="main" v-if="shopTypeData[shopTypeToShow].state != 0"> -->
    <div class="main">
      <div
        class="title"
        v-if="
          !isGeoFlag ||
          toShowShopTypeData.state == 2 ||
          toShowShopTypeData.state == 0
        "
      >
        附近的WiT线下门店
      </div>
      <div class="title" v-if="toShowShopTypeData.state == 1 && isGeoFlag">
        <i class="iconfont icon-tip"></i
        >对不起，该地区还没有线下门店，您可以就近访问以下门店
      </div>
      <!-- <div class="title">附近的WiT线下门店</div> -->
      <content-tab
        :data="shopTypeData"
        :isGeoFlag="isGeoFlag"
        v-model="currentContentIndex"
      >
        <template v-slot:tab1>
          <shop-content
            :state="shopTypeData[1].state"
            :storeList="shopTypeData[1].storeList"
            :isGeoFlag="isGeoFlag"
            :shopType="1"
          ></shop-content
        ></template>
        <template v-slot:tab2
          ><shop-content
            :state="shopTypeData[2].state"
            :storeList="shopTypeData[2].storeList"
            :isGeoFlag="isGeoFlag"
            :shopType="2"
          ></shop-content
        ></template>
      </content-tab>
    </div>
    <wit-picker
      ref="witPicker"
      @cityChange="cityChangeListen"
      @isMaskFirstClick="isMaskFirstClick"
    />
    <mt-popup
      v-model="topPopup"
      position="top"
      :modal="false"
      class="top-popup"
    >
      <i class="iconfont icon-tip"></i>{{ topPopupupMsg }}
    </mt-popup>
  </section>
</template>

<script>
import api from "../../api/store";
import witPicker from "@/components/common/witPicker";
import getGeoLo from "@/assets/js/getGeoLo";
import store from "@/store";
import shopContent from "./shopContent.vue";
import { Indicator } from "mint-ui";
import contentTab from "./contentTab.vue";
export default {
  name: "index-store",
  data() {
    return {
      bannerList: [],
      currentContentIndex: 0,
      shopTypeData: {
        1: {
          storeList: {
            storeList: [],
          },
          state: 2, //0 没有门店  1 附近有门店  2本市有门店
        },
        2: {
          storeList: {
            storeList: [],
          },
          state: 2, //0 没有门店  1 附近有门店  2本市有门店
        },
      },
      selectInfo: {
        city: "北京市",
        cityCode: 0,
      },
      pos: {
        // lng:'120.61990712',//经度
        // lat:'31.31798737',//纬度
        lng: "0", //经度
        lat: "0", //纬度
      },
      topPopup: false, //显示顶部提示
      topPopupupMsg: "获取定位失败，请手动选择地址。",
      isGeoFlag: false, //定位是否成功
      isBroGeo: false, //浏览器是否成功或失败做出回调反应，兼容chrome
    };
  },
  computed: {
    toShowShopTypeData() {
      return this.shopTypeData[this.currentContentIndex + 1];
    },
  },
  watch: {
    topPopup(newVal) {
      if (newVal == true) {
        setTimeout(() => {
          this.topPopup = false;
        }, 3000);
      }
    },
  },
  methods: {
    async getStoresData(params = {}) {
      Indicator.open("正在获取门店信息...");
      const conn1 = api.getStoresData({
        areaId: this.selectInfo.cityCode,
        lng: params.lng || this.pos.lng, //经度
        lat: params.lat || this.pos.lat, //纬度
        shopType: 1,
      });

      const conn2 = api.getStoresData({
        areaId: this.selectInfo.cityCode,
        lng: params.lng || this.pos.lng, //经度
        lat: params.lat || this.pos.lat, //纬度
        shopType: 2,
      });
      const res = await Promise.all([conn1, conn2]);
      // console.log({ res: await Promise.all([conn1, conn2]) });
      Indicator.close();
      const dataProcess = (res, scope) => {
        if (res.code === 0) {
          //设置city名称
          this.selectInfo.city = res.data.area;
          this.$store.state.selectInfo = this.selectInfo;
          if (res.data.shopList.length > 0) {
            //初始化时判断
            if (params.isInit && res.data.shopList[0].distance <= 150) {
              scope.state = 2;
            } else {
              scope.state = 1;
            }
            //手动切换优先选择
            scope.state = params.state || scope.state;
          } else {
            scope.state = 0;
          }

          scope.storeList = res.data;
        }
      };

      dataProcess(res[0], this.shopTypeData[1]);
      dataProcess(res[1], this.shopTypeData[2]);
      this.$store.state.shopTypeData = this.shopTypeData;
      this.$store.state.isGeoFlag = this.isGeoFlag;
      this.$store.state.hasInit = true;
    },

    /**
     * 获取banner
     */
    getShopBanner() {
      api.getshowBanner({ size: 5 }).then((res) => {
        if (res.code == 0) {
          this.bannerList = res.data;
        }
      });
    },
    /**
     * 打开picker
     */
    openPicker() {
      this.$refs.witPicker.regionVisible = true;
    },

    /**
     * 监听picker改变
     * @param city
     */
    async cityChangeListen(info) {
      this.selectInfo = info;
      this.$store.state.selectInfo = this.selectInfo;
      //手动选择区域时state永远为2
      await this.getStoresData({ state: 2 });
    },
    /**
     * 没有点击确认之前是否通过mask点击关闭picker
     */

    isMaskFirstClick(flag) {
      //如果是则请求北京数据
      if (flag) {
        this.getStoresData({
          lng: "116.403039", //经度
          lat: "39.914687", //纬度
        });
      }
    },
    /**
     * 获取经纬度成功时的回调
     * @param position
     */
    getGeoLoSuccess(position) {
      //浏览器对成功或失败做出回调反应
      this.isBroGeo = true;

      //成功获取地理位置信息
      this.isGeoFlag = true;

      this.pos.lat = position.coords.latitude; //纬度
      this.pos.lng = position.coords.longitude; //经度
      console.log("纬度:" + this.pos.lat + ",经度:" + this.pos.lng);

      this.getStoresData({ isInit: true });
    },
    /**
     * 获取经纬度失败时的回调
     * @param error
     */
    getGeoLoFail(error) {
      //浏览器对成功或失败做出回调反应
      this.isBroGeo = true;

      Indicator.close();
      //顶部提示popup
      this.topPopup = true;

      //打开城市选择
      this.openPicker();

      console.warn(error);
    },
  },
  created() {
    if (this.$store.state.hasInit) {
      // this.storeList = this.$store.state.cityData;
      this.shopTypeData = this.$store.state.shopTypeData;
      //浏览器对成功或失败做出回调反应
      this.isBroGeo = true;
      this.selectInfo = this.$store.state.selectInfo;
      if (this.$store.state.isGeoFlag) {
        //定位成功
        this.isGeoFlag = true;
      }
    } else {
      Indicator.open("正在获取门店信息...");
      getGeoLo(this.getGeoLoSuccess, this.getGeoLoFail);
    }
    this.getShopBanner();
  },
  mounted() {
    //chrome使用google的GMS服务，会导致国内用户无法请求到地理位置，也不触发失败回调，需要手动处理
    setTimeout(() => {
      if (!this.isBroGeo) {
        this.getGeoLoFail();
      }
    }, 6000);
  },
  components: {
    witPicker,
    shopContent,
    contentTab,
  },
  store,
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/index.scss";
#wit-store {
  width: 100%;
  flex: 9;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  header {
    width: 100%;
    padding: (22rem / $base) (12rem / $base);
    background: $color-bg-b;
    > div {
      float: left;
      padding: 0 (30rem / $base);
      height: (42rem / $base);
      line-height: (42rem / $base);
      &:nth-of-type(1) {
        font-size: (32rem / $base);
        /*font-size: 32px;*/
        border-right: (1rem / $base) solid $color-text-b;
      }
      &:nth-of-type(2) {
        font-size: (26rem / $base);
        color: #535353;
      }
    }
    .icon-arrow {
      font-size: (12rem / $base);
      margin-left: (10rem / $base);
      color: #666666;
      font-weight: bold;
    }
  }
  .mint-swipe {
    width: 100%;
    height: (343rem / $base);
    a {
      display: block;
      img {
        display: block;
        width: 100%;
        height: (343rem / $base);
      }
    }
  }
  .top-popup {
    width: 100%;
    background: rgba(255, 218, 218, 0.95);
    height: (88rem / $base);
    line-height: (88rem / $base);
    color: #000;
    font-size: (28rem / $base);
    .icon-tip {
      margin: 0 (14rem / $base) 0 (20rem / $base);
      color: #fe6c6c;
    }
  }
  .mint-swipe-indicators {
    width: 100%;
    .mint-swipe-indicator {
      background: #ffffff;
      opacity: 1;
      box-shadow: 0 0 16px 4px rgba(0, 0, 0, 0.1);
    }
    .is-active {
      background: #000000;
    }
  }

  .main {
    width: 100%;
    padding: 0 24rem / $base 24rem / $base;
    box-sizing: border-box;

    background: $color-bg-a;
    // padding: 0 (20rem / $base) (60rem / $base);

    flex: 9;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: center;
    > .title {
      padding: (20rem / $base);
      text-align: center;
      font-size: (24rem / $base);
      color: #282828;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .icon-tip {
      width: 100%;
      color: #e45454;
      font-size: (18rem / $base);
      margin-right: (10rem / $base);
    }
  }
}
</style>
